import React, { useContext } from 'react';
import AppContext from './AppContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './components/Accordion';
import PokedexFilterStatSlider from './PokedexFilterStatSlider';

function PokedexFiltersVariants() {
  const {
    hpRange,
    debouncedSetHpRange,
    attackRange,
    debouncedSetAttackRange,
    defenseRange,
    debouncedSetDefenseRange,
    specialAttackRange,
    debouncedSetSpecialAttackRange,
    specialDefenseRange,
    debouncedSetSpecialDefenseRange,
    speedRange,
    debouncedSetSpeedRange,
  } = useContext(AppContext);

  return (
    <Accordion type="single" collapsible defaultValue="base-stats">
      <AccordionItem value="base-stats-filter">
        <AccordionTrigger>Stats Filter</AccordionTrigger>
        <AccordionContent>
          <PokedexFilterStatSlider
            label="HP"
            initialValue={hpRange}
            globalRangeOnChange={debouncedSetHpRange}
          />
          <PokedexFilterStatSlider
            label="Attack"
            initialValue={attackRange}
            globalRangeOnChange={debouncedSetAttackRange}
          />
          <PokedexFilterStatSlider
            label="Defense"
            initialValue={defenseRange}
            globalRangeOnChange={debouncedSetDefenseRange}
          />
          <PokedexFilterStatSlider
            label="Special Attack"
            initialValue={specialAttackRange}
            globalRangeOnChange={debouncedSetSpecialAttackRange}
          />
          <PokedexFilterStatSlider
            label="Special Defense"
            initialValue={specialDefenseRange}
            globalRangeOnChange={debouncedSetSpecialDefenseRange}
          />
          <PokedexFilterStatSlider
            label="Speed"
            initialValue={speedRange}
            globalRangeOnChange={debouncedSetSpeedRange}
          />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}

export default PokedexFiltersVariants;
